<template>
	<div class="locale-switcher">
		<!-- <select v-model="$i18n.locale"> -->
			<!-- <option value="sv-SE">Svenska</option> -->
			<!-- <option value="en-US">English</option> -->
		<!-- </select> -->
		<img v-if="locale == 'sv-SE'" class="flag" src='@/assets/flag-sv.svg' role="button" @click="toggleLanguage">
		<img v-else-if="locale == 'en-US'" class="flag" src='@/assets/flag-en.svg' role="button" @click="toggleLanguage">
	</div>
</template>



<script>
export default {
	mounted() {
		if (localStorage.language) {
			this.$i18n.locale = localStorage.language;
		}
		this.$log.onLanguageChange(this.$i18n.locale, false);
	},
	methods: {
		toggleLanguage() {
			if (this.$i18n.locale == "sv-SE") {
				this.$i18n.locale = "en-US";
			}
			else {
				this.$i18n.locale = "sv-SE";
			}
			this.$log.onLanguageChange(this.$i18n.locale, true);
		}
	},
	computed: {
		locale() {
			return this.$i18n.locale;
		}
	},
	watch: {
		locale() {
			localStorage.language = this.$i18n.locale;
		}
	},
};
</script>



<style scoped>
	.flag {
		height: 2em;
		margin: -2.2em 0 -2em 0.5em;
	}
</style>
